import styled, { keyframes, css } from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';

import { TableTitleBox } from './row/rows.sc';

export const hideAnimationSpeed = 300;

const hide = keyframes`
  from {
    width: 222px;
    padding: 10px;
  }
  to {
    width: 0;
    padding: 0;
  }
`;

const grow = keyframes`
  0% {
    width: 0;
    padding: 0;
    visibility: hidden;
  }
  99% {
    visibility: hidden;
  }
  100% {
    width: 221px;
    padding: 10px;
    visibility: visible;
  }
`;

export const TopicTitleContainer = styled(TableTitleBox)<{ $isFixed?: boolean; $isHidden?: boolean }>`
  ${({ theme, $isFixed, $isHidden }) => css`
    cursor: pointer;
    visibility: ${$isHidden ? 'hidden' : 'visible'};
    border-right: ${$isFixed ? 'none' : `1px solid ${theme.black.a1}`};
    width: ${$isFixed ? '100%' : $isHidden ? '0' : '221px'};
    height: 50px;
    min-height: 50px;
    transition: transform 100ms ease-in-out, opacity 100ms ease-in-out;
    &:hover {
      min-height: 50px;
      color: ${theme.baseBlue.a6};
    }
    &.entering {
      transform: translate(0, 15px);
      opacity: 0;
      animation: ${grow} ${hideAnimationSpeed}ms ease;
      overflow: hidden;
    }
    &.exiting {
      animation: ${hide} ${hideAnimationSpeed}ms ease;
      overflow: hidden;
    }
    &.entered {
      transform: translate(0, 0);
      opacity: 1;
    }
    &.exited {
      border-right: none;
      width: 0;
      padding: 0;
      display: none;
    }
  `}
`;

export const CaretContainer = styled(SvgIcon)<{ $isFixed?: boolean }>`
  transform: ${({ $isFixed }) => ($isFixed ? 'rotate(360deg)' : 'rotate(270deg)')};
  transition: transform 0.5s ease-in-out;
  color: inherit;
  min-width: 15px;
  svg {
    stroke-width: 2px;
  }
`;
